<template>
  <div>
    <div class="clearfix">
      <a-upload class="document" list-type="picture-card" multiple :file-list="model.document_attacheds"
        @preview="handlePreview" :before-upload="beforeUpload" :remove="removeFile">
        <div v-if="model.document_attacheds.length < 8">
          <a-icon type="plus" />
          <div class="ant-upload-text">
            {{ $t('upload') }}
          </div>
        </div>
      </a-upload>
      <a-modal :visible="previewVisible" :footer="null" @cancel="handleCancel">
        <img alt="example" style="width: 100%" :src="previewImage" />
      </a-modal>
    </div>
  </div>
</template>
<script>
export default {
  name: 'documentAttached',
  props: ['value', 'validate'],
  data() {
    return {
      previewVisible: false,
      previewImage: '',
      model: {}
    }
  },
  created() {
    this.model = this.value
  },
  computed: {},
  methods: {
    handleCancel() {
      this.previewVisible = false
    },
    async handlePreview(file) {
      if (!file.url && !file.preview) {
        file.preview = await this.getBase64(file.originFileObj)
      }
      this.previewImage = file.url || file.preview
      this.previewVisible = true
    },
    getBase64(file) {
      return new Promise((resolve, reject) => {
        const reader = new FileReader()
        reader.readAsDataURL(file)
        reader.onload = () => resolve(reader.result)
        reader.onerror = error => reject(error)
      })
    },
    removeFile(file) {
      let document_attacheds = this.model.document_attacheds.find(
        f => f.name == file.name
      )
      let file_index = this.model.document_attacheds.indexOf(document_attacheds)
      this.model.document_attacheds.splice(file_index, 1)
    },
    beforeUpload(file) {
      let new_file = {
        id: null,
        uid: file.uid,
        name: file.name,
        status: 'done',
        file_path: null,
        mime_type: file.type,
        size: parseInt(file.size / 1024),
        url: URL.createObjectURL(file),
        file: file
      }
      this.model.document_attacheds = [
        ...this.model.document_attacheds,
        new_file
      ]

      return false
    }
  }
}
</script>
<style>
.document>.ant-upload {
  width: 60px;
  height: 60px;
  margin: 6px 0 0 6px;
}

.document .ant-upload-list-picture-card-container {
  width: 60px;
  height: 60px;
  margin: 0 6px 6px 0;
}

.document>.ant-upload-list-picture-card .ant-upload-list-item {
  width: 60px;
  height: 60px;
  margin: 6px 0 0 6px;
  padding: 3px;
}

.ant-upload-select-picture-card i {
  font-size: 24px;
  color: #999;
}

.ant-upload-select-picture-card .ant-upload-text {
  color: #666;
  font-size: 12px;
}
</style>
